import vClickOutside from 'click-outside-vue3';
import FloatingVue from 'floating-vue';
import Icon from 'commons/icon/component/Icon.vue';
import VueTheMask from 'vue-the-mask';

import date from 'commons/date/date';
import sprdCurrency from 'commons/currency/filter/currencyFilter';
import sprdNumber from 'commons/number/numberFilter';
import trackClickEvent from 'commons/tracking/trackClickEvent';
import maxInputLength from 'commons/maxInputLength/maxInputLength';
import selectOnBlur from 'commons/tagInput/selectOnBlur/selectOnBlur';
import selectOnComma from 'commons/tagInput/selectOnComma/selectOnComma';
import selectOnWhitespace from 'commons/tagInput/selectOnWhitespace/selectOnWhitespace';
import selectOnClick from 'commons/selectOnClick/selectOnClick';
import { i18n } from 'commons/translate/i18n';

export default {
  install(app) {
    app.use(i18n);
    app.use(FloatingVue, {
      themes: {
        'tooltip-dark': {
          $extend: 'tooltip',
        },
        'tooltip-navbar': {
          $extend: 'tooltip',
        },
        'tooltip-no-arrow': {
          $extend: 'tooltip',
        },
        'sample-order-hint': {
          $extend: 'tooltip',
        },
      },
    });
    app.use(vClickOutside);
    app.use(VueTheMask);

    app.component('Icon', Icon);

    app.mixin({
      methods: {
        sprdCurrency: sprdCurrency,
        sprdNumber: sprdNumber,
        date: date,
      },
    });

    app.directive('trackClickEvent', trackClickEvent);
    app.directive('maxInputLength', maxInputLength);
    app.directive('selectOnBlur', selectOnBlur);
    app.directive('selectOnComma', selectOnComma);
    app.directive('selectOnWhitespace', selectOnWhitespace);
    app.directive('selectOnClick', selectOnClick);
  },
};
